import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NavbarText from '../components/NavbarText';
import TbmCrrStatusList from '../components/tbm-crr-status/TbmCrrStatusList';
import TbmCrrStatusDetail from '../components/tbm-crr-status/TbmCrrStatusDetail';
import * as securityHelper from "../helper/SecurityHelper";
import axios from "axios";

interface ITBMStatus {
  comName: string;
  safetyStatus: boolean;
  siteStatus: boolean;
  totWorker: number;
  doneWorker: number;
  startDate: Date;
  endDate: Date;
  company: string;
}
interface ITBMDetail {
  workerName: string;
  startTime: string;
  endTime: string;
  tbmComplete: boolean;
}

export default function TbmCrrStatus() {
  const navigate = useNavigate();
  const [tab, setTab] = useState('');
  const [tbmStatus, setTbmStatus] = useState<ITBMStatus[]>();
  const [tbmStatusView, setTbmStatusView] = useState<ITBMStatus[]>();
  const [tbmDetail, setTbmDetail] = useState<any>();
  const now = new Date();
  const [date, setDate] = useState<Date>(new Date());
  const [selectHostData, setSelectHostData] = useState<any>([]);
  const [selectHost, setSelectHost] = useState<any>('');
  const [selectComData, setSelectComData] = useState<string[]>([]);
  const [selectCom, setSelectCom] = useState('');
  const user = securityHelper.getLoginUser();
  // 유저 auth 정보 storage 에서 바로 당겨와야 데이터를 가져오는 비동기 함수가 바로 실행이 됨.
  // state로 auth를 관리하면 auth가 세팅되는 동안 다른 컴포넌트들이 렌더되어 빈 페이지가 뜸.
  const auth = securityHelper.getLoginUser().auth;
  const detailHandler = (data: any) => {

    console.log('data: ', data);
    const cmpnySeq = data.cmpnySeq;

    if (tab !== 'detail') {
      setTab('detail');
    };
    setSelectCom(data.cmpnyNm);
    // axios로 name(업체명)에 해당하는 tbm현황 상세정보 가져오기
    fn_retrieveIdvSmrtTbmStatDataList(cmpnySeq);


  };
  const backEvent = () => {
    if (auth === 'KOX' || auth === 'COM') {
      if (tab === 'list') { navigate(-1) }
      else { setTab('list') };
    } else { navigate(-1) };
  }
  useEffect(() => {
    if (auth === 'SRV') {
      setTab('detail');
    } else {
      setTab('list')
    }
  }, [])
  useEffect(() => {
    // 'KOX' or 'COM' List Data
    if (auth === 'KOX' || auth === 'COM') {
      setTbmStatusView(tbmStatus);
    }
  }, [tbmStatus]);
  useEffect(() => {
    if (date) {
      if (auth === 'KOX') {
        fn_retrieveTbmStatByCmpnyDataList(0);
        fn_retrieveHstListByProd();
        setSelectHost('');
      } else if (auth === 'COM') {
        fn_retrieveTbmStatByCmpnyDataList(user.companySeq);
        setSelectHost(user.companySeq);
      } else if (auth === 'SRV') {
        setSelectHost('');
        fn_retrieveIdvSmrtTbmStatDataList(user.companySeq);
      }
    }

  }, [date]);

  useEffect(() => {
    if (auth === 'KOX') {
      // 주최사에 따라 데이터 출력
      if (selectHost) {
        fn_retrieveTbmStatByCmpnyDataList(selectHost);
      } else {
        fn_retrieveTbmStatByCmpnyDataList(0);
      }
    }

  }, [selectHost])

  const fn_retrieveHstListByProd = async () => {
    const rtrnData = await axios.post('admin/api/cmpny/retrieveHstDataListByEvntProd', { date: date });
    setSelectHostData(rtrnData.data);
  }

  const fn_retrieveTbmStatByCmpnyDataList = async (hstCmpnySeq: any) => {
    const rtrnData = await axios.post('admin/api/tbm/retrieveTbmStatByCmpnyDataList', { date: date, hstCmpnySeq: hstCmpnySeq });
    setTbmStatus(rtrnData.data);
  }

  const fn_retrieveIdvSmrtTbmStatDataList = async (cmpnySeq: any) => {
    const rtrnData = await axios.post('admin/api/tbm/retrieveIdvSmrtTbmStatDataList', { date: date, cmpnySeq: cmpnySeq, hstCmpnySeq: selectHost });
    setTbmDetail(rtrnData.data);
  }


  return (
    <div className='w-screen h-[calc(100dvh)] relative'>
      <NavbarText backEvent={backEvent}>TBM 현황</NavbarText>
      {tab === 'list'
        ? <TbmCrrStatusList tbmStatusView={tbmStatusView} selectHost={selectHost} setSelectHost={setSelectHost} date={date} setDate={setDate} selectHostData={selectHostData} detailHandler={detailHandler} auth={auth} />
        : <TbmCrrStatusDetail tbmDetail={tbmDetail} selectCom={selectCom} setSelectCom={setSelectCom} selectComData={selectComData} date={date} setDate={setDate} detailHandler={detailHandler} auth={auth} />}
    </div>
  );
}

